export default __webpack_public_path__ + "static/media/giftcard.af785833.jpg";